export default "__VITE_ASSET__CQwO6IWm__"